import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AboutUs from './pages/AboutUs';
import './App.css';
import './component/css/style.css';
import './component/css/common.css';
import './component/css/admin.css';
import { HeadProvider, Title, Meta } from 'react-head';

import { CartProvider } from './context/CartContext';


import VisitorNavbar from './component/VisitorNavbar';
import Footer from './component/Footer';
import ProductDetail from './pages/ProductDetail';
import ContactUs from './pages/ContactUs';
import AllProduct from './pages/AllProduct';
import CustomerLogin from './pages/CustomerLogin';
import CustomerRegister from './pages/CustomerRegister';
import CustomerForgetPassword from './pages/CustomerForgetPassword';
import CustomerMyAccount from './pages/CustomerMyAccount';
import CustomerChangePassword from './pages/CustomerChangePassword';
import Cart from './pages/Cart';
import MyInquiry from './pages/MyInquiry';
import ShippingAddress from './pages/ShippingAddress';
import Checkout from './pages/Checkout';
import PerformaInvoice from './pages/Invoice/PerformaInvoice';
import PaymentPage from './pages/PaymentPage';
import MyOrders from './pages/MyOrders';
import OrderDetail from './pages/OrderDetail';
import AllMyOrders from './pages/Seller/AllMyOrders';
import ChangePassword from './pages/ChangePassword';
import CustomerResetPassword from './pages/CustomerResetPassword';
import Search from './pages/Search';
import Searchs from './pages/Searchs';


import ServiceRepair from './pages/Service/ServiceRepair';


import PerformaInvoiceAdmin from './pages/Invoice/PerformaInvoiceAdmin';

import NewProduct from './pages/NewProduct';
import LeagalNotice from './pages/LeagalNotice';

import AdminDashboard from './pages/Admin/AdminDashboard';
import AdminLogin from './pages/Admin/AdminLogin';
 
import AllSubcategory from './pages/Admin/AllSubcategory';
import AllBrand from './pages/Admin/AllBrand';
import CustomerReport from './pages/Admin/CustomerReport';
import SellerReport from './pages/Admin/SellerReport';
import EditSubcategory from './pages/Admin/AdminComp/EditSubcategory';
import EditBrand from './pages/Admin/AdminComp/EditBrand';
import AdminBanners from './pages/Admin/AdminBanners';
import AllFullBanner from './pages/Admin/AdminComp/AllFullBanner';
import EditBanner from './pages/Admin/AdminComp/EditBanner';
import AllHalfBanner from './pages/Admin/AdminComp/AllHalfBanner';
import AdminBannersHalf from './pages/Admin/AdminBannersHalf';
import AdminSellerListing from './pages/Admin/AdminSellerListing';
import AdminEditListings from './pages/Admin/AdminEditListings';
import MenuForm from './pages/Admin/MenuForm';
import EditMenu from './pages/Admin/AdminComp/EditMenu';
import UserAllOrderAdmin from './pages/Admin/UserAllOrderAdmin';
import AdminAddAdmin from './pages/Admin/AdminAddAdmin';
import EditAdmin from './pages/Admin/AdminComp/EditAdmin';
import CategoryBuilder from './pages/Admin/CategoryBuilder';
import CategoryBuilderSub from './pages/Admin/CategoryBuilderSub'; 
import NewMenuForm from './pages/Admin/AdminComp/NewMenuForm';
import ModalNumber from './pages/Admin/MenuForm/ModalNumber';
import ItemCategory from './pages/Admin/MenuForm/ItemCategory';
import SubCategory from './pages/Admin/MenuForm/SubCategory';
import MakeBrand from './pages/Admin/MenuForm/MakeBrand';
import InstrumentType from './pages/Admin/MenuForm/InstrumentType';
import AllCategory from './pages/Admin/MenuForm/AllCategory';
import EditCategory from './pages/Admin/MenuForm/EditCategory';
import SixLevelMenu from './pages/Admin/MenuForm/SixLevelMenu';
import SevenLevelMenu from './pages/Admin/MenuForm/SevenLevelMenu';
import EightLevelMenu from './pages/Admin/MenuForm/EightLevelMenu';
import NineLevelMenu from './pages/Admin/MenuForm/NineLevelMenu';
import TenLevelMenu from './pages/Admin/MenuForm/TenLevelMenu';
import AllTrashCategory from './pages/Admin/MenuForm/AllTrashCategory';
import AddCountry from './pages/Admin/AddCountry';
import AddState from './pages/Admin/AddState';
import FooterDetails from './pages/Admin/FooterDetails';
import AddTerms from './pages/Admin/AdminComp/AddTerms';
import AllOtherBanner from './pages/Admin/AdminComp/AllOtherBanner';
import AddCoupon from './pages/Admin/AddCoupon';
import AllCoupon from './pages/Admin/AllCoupon';
import ApproveListing from './pages/Admin/ApproveListing';
import AllSellerAdmin from './pages/Admin/AllSellerAdmin';
import SellerDetail from './pages/Admin/SellerDetail';
import CustomerDetail from './pages/Admin/CustomerDetail';
import AllCustomerAdmin from './pages/Admin/AllCustomerAdmin';
import AllCustomerOTP from './pages/Admin/AllCustomerOTP';
import Installation from './pages/Admin/Installation';
import AddPrivacy from './pages/Admin/AdminComp/AddPrivacy';
import AddShippingPolicy from './pages/Admin/AdminComp/AddShippingPolicy';
import AddReturn from './pages/Admin/AdminComp/AddReturn';
import AddLeagalNotice from './pages/Admin/AdminComp/AddLeagalNotice';
import AddAbout from './pages/Admin/AdminComp/AddAbout';
import AllListing from './pages/Admin/AllListing';
import ApproveListingDetail from './pages/Admin/ApproveListingDetail';
import AllApprovedListing from './pages/Admin/AllApprovedListing';
import AdminDirectPurchaseRequest from './pages/Admin/AdminDirectPurchaseRequest';
import ServiceCategory from './pages/Admin/ServiceCategory/ServiceCategory';
import Category from './pages/Admin/ServiceCategory/Category';
import ServiceSubCategory from './pages/Admin/ServiceCategory/ServiceSubCategory';
import ServiceSubSubCategory from './pages/Admin/ServiceCategory/ServiceSubSubCategory';
import ServiceStateCity from './pages/Admin/ServiceCategory/ServiceStateCity';
import ServiceCity from './pages/Admin/ServiceCategory/ServiceCity';
import AllServiceCategory from './pages/Admin/ServiceCategory/AllServiceCategory';
import ServiceTeamEdit from './pages/Seller/ServiceTeamEdit';

import EditServiceCategory from './pages/Admin/ServiceCategory/EditServiceCategory';

import EducationCategory from './pages/Admin/EducationCategory.js/EducationCategory';
import SubCategoryEducation from './pages/Admin/EducationCategory.js/SubCategoryEducation';
import EducationSubSubCategory from './pages/Admin/EducationCategory.js/EducationSubSubCategory';
import AllEducationCategory from './pages/Admin/EducationCategory.js/AllEducationCategory';
import AdminAddEducation from './pages/Admin/AdminAddEducation';
import AllEducationProfile from './pages/Admin/AllEducationProfile';
import EditEducationCategory from './pages/Admin/EducationCategory.js/EditEducationCategory'; 

import AddTestimonial from './pages/Admin/AddTestimonial';
 

import AdminProfile from './pages/Admin/AdminProfile';

import SellerLogin from './pages/Seller/SellerLogin';
import SellerRegister from './pages/Seller/SellerRegister';
import SellerProfile from './pages/Seller/SellerProfile';
import SellerListingCreate from './pages/Seller/SellerListingCreate';
import SellerDashboard from './pages/Seller/SellerDashboard';
import SellerAllListing from './pages/Seller/SellerAllListing';
import ListingTwo from './pages/Seller/ListingTwo';
import EditListing from './pages/Seller/EditListing';
import EditListingImage from './pages/Seller/EditListingImage';
import UpdateProductImage from './pages/Seller/SellerComp/UpdateProductImage';
import SellerOtp from './pages/Seller/SellerOtp';
import VerifyOtp from './pages/VerifyOtp';
import CustomerProfile from './pages/CustomerProfile';
import SellerBulkUpload from './pages/Seller/SellerBulkUpload';
import MyInquireySeller from './pages/Seller/MyInquireySeller';
import ListingCatelog from './pages/Seller/ListingCatelog';
import BusinessProfile from './pages/Seller/BusinessProfile';
import PolicyCharges from './pages/Seller/PolicyCharges';
import SellerOrderDetail from './pages/Seller/SellerOrderDetail';
import SellerChangePassword from './pages/Seller/SellerChangePassword';
import AllProductEnquery from './pages/Seller/AllProductEnquery';
import SellerForgotPassword from './pages/Seller/SellerForgotPassword';
import SellerResetPassword from './pages/Seller/SellerResetPassword';
import ActiveCategory from './pages/Admin/ActiveCategory';
import AllListingCost from './pages/Admin/AllListingCost';
import AdminSellerAllOrder from './pages/Admin/AdminSellerAllOrder';
import ServiceTeam from './pages/Seller/ServiceTeam';
import ServiceTeamAdd from './pages/Seller/ServiceTeamAdd';


import AddSellerTerms from './pages/Admin/AdminComp/AddSellerTerms';
import SellerTerm from './component/StaticPages/SellerTerm';

import AdminAllOrder from './pages/Admin/AdminAllOrder';
import AdminCuatomerOrders from './pages/Admin/AdminCuatomerOrders';
import AdminSellerOrders from './pages/Admin/AdminSellerOrders';
import RejectedListing from './pages/Admin/RejectedListing';
import DirectSellRequest from './pages/Seller/DirectSellRequest';
import ServiceProfile from './pages/Service/ServiceProfile';
import AdminAllEnquiry from './pages/Admin/AdminAllEnquiry';

// blog 
import BlogAddCategory from './pages/Admin/BlogAddCategory';
import BlogAdd from './pages/Admin/BlogAdd';
import BlogEdit from './pages/Admin/BlogEdit';
import BlogList from './pages/Admin/BlogList';
import Blogs from './pages/Blogs';
import BlogDetail from './pages/BlogDetail';
import SearchQuery from './pages/SearchQuery';



import PaymentGateway from './pages/PaymentGateway';

import Categories from './pages/Categories';
import CategoriesSub from './pages/CategoriesSub';

import Terms from './component/StaticPages/Terms';
import Privacy from './component/StaticPages/Privacy';
import Shipping from './component/StaticPages/Shipping';
import Return from './component/StaticPages/Return';
import AdminSetting from './pages/Admin/AdminSetting';

import ProductDetailtwo from './pages/ProductDetailtwo';



import PaymentFailure from './pages/PaymentFailure';
import PaymentSuccess from './pages/PaymentSuccess';
import Whatsapp from './component/Whatsapp';

import Education from './pages/Education';

import OrderDetailAdmin from './pages/Admin/OrderDetailAdmin';
import EducationSubSubSubCategory from './pages/Admin/EducationCategory.js/EducationSubSubSubCategory';

import EditEducationProfile from './pages/Admin/EditEducationProfile';

import DownloadApproved from './pages/Admin/DownloadApproved';
import ApprovalPending from './pages/Seller/ApprovalPending';
import SellerListCost from './pages/Admin/SellerListCost';
import SellerListingPrice from './pages/Admin/SellerListingPrice';
import BulkUpload from './pages/Seller/BulkUpload';
import BillToShipTo from './pages/Admin/BillToShipTo';
import ProductReviews from './pages/Admin/ProductReviews';
import AllServiceRequest from './pages/Service/AllServiceRequest';
import AllServiceRequestAdmin from './pages/Admin/AllServiceRequest';
import PaypalPaymentGateway from './pages/PaypalPaymentGateway';
import AdminContact from './pages/Admin/AdminContact';
import AdminSellerQuote from './pages/Admin/AdminSellerQuote';
import AddressManagement from './pages/AddressManagement';
import GetSellerAccess from './pages/Admin/GetSellerAccess';

function App() {
  return (
    <HeadProvider>
    <CartProvider>
    <Router>
      <div className="App">
        {/* <VisitorNavbar/> */}
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/product/:slug" element={<ProductDetail />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/shop/:slug" element={<AllProduct />} />
            <Route path="/customer/login" element={<CustomerLogin />} />
            <Route path="/customer/create-account" element={<CustomerRegister />} />
            <Route path="/customer/forget-password" element={<CustomerForgetPassword />} />
            <Route path="/my-account" element={<CustomerMyAccount />} />
            <Route path="/customer/change-password" element={<CustomerChangePassword />} />
            <Route path="/verifyotp" element={<VerifyOtp />} />
            <Route path="/customer/profile" element={<CustomerProfile />} />
            <Route path="/categories/:slug" element={<Categories />} />
            <Route path="/sub-categories/:slug" element={<CategoriesSub />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/terms-and-conditions" element={<Terms />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/shipping-policy" element={<Shipping />} />
            <Route path="/return-policy" element={<Return />} />
            <Route path="/search/" element={<Search />} />
            <Route path="/searchs/:slug" element={<Searchs />} />
            
            

            <Route path="/my-inquiry" element={<MyInquiry />} />
            <Route path="/performa-invoice/:orderId" element={<PerformaInvoice />} />
            <Route path="/performa-invoice-admin/:orderId" element={<PerformaInvoiceAdmin />} />
            <Route path="/shipping-address" element={<ShippingAddress />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/payment" element={<PaymentPage />} />
            <Route path="/payment-gateway-paypal" element={<PaypalPaymentGateway />} />
            <Route path="/my-orders" element={<MyOrders />} />
            <Route path="/order-details/:orderid/:sellerId" element={<OrderDetail />} />
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/customer/reset-password/:token" element={<CustomerResetPassword />} />
            
            
            <Route path="/latest-product" element={<NewProduct />} />
            <Route path="/legal-notice" element={<LeagalNotice />} />


            <Route path="/payment-gateway" element={<PaymentGateway />} />
            <Route path="/payment-failure" element={<PaymentFailure />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/search-query/:query" element={<SearchQuery />} />
            <Route path="/service-repair" element={<ServiceRepair />} />
            
            
            
          </Routes>

          <Routes>
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          {/* <Route path="/admin/category" element={<AllCategory />} /> */}
          {/* <Route path="/admin/sub-category" element={<AllSubcategory />} /> */}
          <Route path="/admin/brand" element={<AllBrand />} />
          <Route path="/admin/customer-report" element={<CustomerReport />} />
          <Route path="/admin/seller-report" element={<SellerReport />} />
          <Route path="/admin/edit-subcategory/:id/:categoryId/:subCategoryName" element={<EditSubcategory />} />
          <Route path="/admin/edit-brand/:id/:brand_name" element={<EditBrand />} />
          <Route path="/admin/banner" element={<AdminBanners />} />
          <Route path="/admin/full-banner" element={<AllFullBanner />} />
          <Route path="/admin/edit-banner/:id" element={<EditBanner />} />
          <Route path="/admin/half-banner" element={<AllHalfBanner />} />
          <Route path="/admin/banner-half" element={<AdminBannersHalf />} />
          <Route path="/admin/seller-all-listing/:seller_id" element={<AdminSellerListing />} />
          <Route path="/admin/edit-listing/:listing_id" element={<AdminEditListings />} />
          <Route path="/admin/menu-form" element={<MenuForm />} />
          <Route path="/admin/edit-menu/:id" element={<EditMenu />} />
          <Route path="/admin/user-all-orders/:id" element={<UserAllOrderAdmin />} />
          <Route path="/add-admin" element={<AdminAddAdmin />} />
          <Route path="/edit-admin/:id" element={<EditAdmin />} />
          {/* <Route path="/admin/item-category" element={<CategoryBuilder />} /> */}
          <Route path="/admin/item-category-sub" element={<CategoryBuilderSub />} />
          {/* <Route path="/admin/modal-number" element={<NewMenuForm />} /> */}
          <Route path="/admin/modal-number" element={<ModalNumber />} />
          <Route path="/admin/item-category" element={<ItemCategory />} />
          <Route path="/admin/sub-category" element={<SubCategory />} />
          <Route path="/admin/make-brand" element={<MakeBrand />} />
          <Route path="/admin/instrument-type" element={<InstrumentType />} />
          <Route path="/admin/all-category" element={<AllCategory />} />
          <Route path="/admin/edit-category/:id" element={<EditCategory />} />
          <Route path="/admin/sellerlistingspricelist/:seller_id" element={<SellerListingPrice />} />
 
          <Route path="/admin/six-category" element={<SixLevelMenu />} />
          <Route path="/admin/seven-category" element={<SevenLevelMenu />} />
          <Route path="/admin/eight-category" element={<EightLevelMenu />} />
          <Route path="/admin/nine-category" element={<NineLevelMenu />} />
          <Route path="/admin/ten-category" element={<TenLevelMenu />} />
          <Route path="/admin/all-trash-category" element={<AllTrashCategory />} />
          <Route path="/admin/add-country" element={<AddCountry />} />
          <Route path="/admin/add-state" element={<AddState />} />
          <Route path="/admin/footer-details" element={<FooterDetails />} />
          <Route path="/admin/terms-condition" element={<AddTerms />} />
          <Route path="/admin/new-banner" element={<AllOtherBanner />} />
          <Route path="/admin/add-coupon" element={<AddCoupon />} />
          <Route path="/admin/all-coupon" element={<AllCoupon />} />
          <Route path="/admin/approve-listing" element={<ApproveListing />} />
          <Route path="/admin/all-sellers" element={<AllSellerAdmin />} />
          <Route path="/admin/seller-detail/:uniqueid" element={<SellerDetail />} />
          <Route path="/admin/customer-detail/:uniqueid" element={<CustomerDetail />} />
          <Route path="/admin/all-customer" element={<AllCustomerAdmin />} />
          <Route path="/admin/all-customer-otp" element={<AllCustomerOTP />} />
          <Route path="/admin/seller-listing-details/:id" element={<ApproveListingDetail />} />
          <Route path="/admin/all-approved-listing" element={<AllApprovedListing />} />
          <Route path="/admin/all-rejected-listing" element={<RejectedListing />} />
          <Route path="/admin/direct-purchase" element={<AdminDirectPurchaseRequest />} />
          <Route path="/admin/order-detail/:orderid/:sellerId" element={<OrderDetailAdmin />} />
          <Route path="/admin/seller-list-cost" element={<SellerListCost />} />
          <Route path="/get-access/:id/:name" element={<GetSellerAccess />} />
          
          
          <Route path="/admin/edit-education-category/:id" element={<EditEducationCategory />} />
          <Route path="/admin/edit-service-category/:id" element={<EditServiceCategory />} />
          <Route path="/admin/profile" element={<AdminProfile />} />
          <Route path="/admin/review" element={<ProductReviews />} />
          <Route path="/admin/contact" element={<AdminContact />} />
          <Route path="/admin/seller-quote" element={<AdminSellerQuote />} />







          <Route path="/admin/add-privacy" element={<AddPrivacy />} />
          <Route path="/admin/add-shipping-policy" element={<AddShippingPolicy />} />
          <Route path="/admin/add-return-policy" element={<AddReturn />} />
          <Route path="/admin/add-legal-notice" element={<AddLeagalNotice />} />
          <Route path="/admin/add-about-us" element={<AddAbout />} />
          <Route path="/admin/installation" element={<Installation />} />
          <Route path="/admin/all-listings" element={<AllListing />} />
          <Route path="/admin/active-category" element={<ActiveCategory />} />
          <Route path="/admin/all-listings-cost" element={<AllListingCost />} />
          <Route path="/admin/setting" element={<AdminSetting />} />
          <Route path="/admin/seller-all-order/:id" element={<AdminSellerAllOrder />} />
          
          <Route path="/admin/add-terms-seller" element={<AddSellerTerms />} />
          <Route path="/admin/add-blog-category" element={<BlogAddCategory />} />
          <Route path="/admin/add-blog" element={<BlogAdd />} />
          <Route path="/admin/blog-edit/:id" element={<BlogEdit />} />
          <Route path="/admin/blog-list" element={<BlogList />} />

          <Route path="/admin/all-orders" element={<AdminAllOrder />} />
          <Route path="/admin/ship-to" element={<BillToShipTo />} />
          <Route path="/admin/customer-order/:id" element={<AdminCuatomerOrders />} />
          <Route path="/admin/seller-order/:id" element={<AdminSellerOrders />} />
          <Route path="/admin/service-category" element={<ServiceCategory />} />
          <Route path="/admin/category" element={<Category />} />
          <Route path="/admin/sub-category-service" element={<ServiceSubCategory />} />
          <Route path="/admin/sub-sub-category-service" element={<ServiceSubSubCategory />} />

          

          <Route path="/admin/state-city-service" element={<ServiceStateCity />} />
          <Route path="/admin/city-service" element={<ServiceCity />} />
          <Route path="/admin/all-service-category" element={<AllServiceCategory />} />
          <Route path="/admin/all-service-request" element={<AllServiceRequestAdmin />} />
          <Route path="/admin/all-enquiry" element={<AdminAllEnquiry />} />
          <Route path="/admin/education-category" element={<EducationCategory />} />
          <Route path="/admin/education-sub-category" element={<SubCategoryEducation />} />
          <Route path="/admin/education-sub-sub-category" element={<EducationSubSubCategory />} />
          <Route path="/admin/education-sub-sub-sub-category" element={<EducationSubSubSubCategory />} />
          

          <Route path="/admin/all-education-category" element={<AllEducationCategory />} />
          <Route path="/admin/add-education" element={<AdminAddEducation />} />
          <Route path="/admin/all-education" element={<AllEducationProfile />} />
          <Route path="/admin/edit-education/:id" element={<EditEducationProfile />} />
          <Route path="/admin/testimonial" element={<AddTestimonial />} />
          <Route path="/admin/download" element={<DownloadApproved />} />
          
          </Routes>


          <Routes>
          <Route path="/seller/login" element={<SellerLogin />} /> 
          <Route path="/seller/register" element={<SellerRegister />} /> 
          <Route path="/seller/profile" element={<SellerProfile />} /> 
          <Route path="/seller/create-listing" element={<SellerListingCreate />} /> 
          <Route path="/seller/dashboard" element={<SellerDashboard />} /> 
          <Route path="/seller/all-listing" element={<SellerAllListing />} /> 
          <Route path="/seller/listing-two/:listing_id" element={<ListingTwo />} /> 
          <Route path="/seller/edit-listing/:listing_id" element={<EditListing />} /> 
          <Route path="/seller/listing-images/:listing_id/:seller_id" element={<EditListingImage />} /> 
          <Route path="/seller/listing-images-product/:listing_id" element={<UpdateProductImage />} /> 
          <Route path="/seller/otp" element={<SellerOtp />} /> 
          <Route path="/seller/bulk-listing" element={<SellerBulkUpload />} /> 
          <Route path="/seller/my-inquiry" element={<MyInquireySeller />} /> 
          <Route path="/seller/listing-categlog/:listing_id/:seller_id" element={<ListingCatelog />} /> 
          <Route path="/seller/business-profile" element={<BusinessProfile />} /> 
          <Route path="/seller/policy-charges/:listing_id" element={<PolicyCharges />} /> 
          <Route path="/seller/my-orders" element={<AllMyOrders />} /> 
          <Route path="/order/:orderid" element={<SellerOrderDetail />} /> 
          <Route path="/seller/change-password" element={<SellerChangePassword />} /> 
          <Route path="/seller/all-enquiry" element={<AllProductEnquery />} /> 
          <Route path="/seller/forgot-password" element={<SellerForgotPassword />} /> 
          <Route path="/seller/reset-password/:token" element={<SellerResetPassword />} /> 
          <Route path="/seller/bulk-upload" element={<BulkUpload />} /> 
 
          <Route path="/seller/terms" element={<SellerTerm />} /> 
          <Route path="/seller/direct-purchase-request" element={<DirectSellRequest />} />
          <Route path="/seller/service-team" element={<ServiceTeam />} />
          <Route path="/seller/service-request" element={<AllServiceRequest />} />
          <Route path="/seller/service-team-create" element={<ServiceTeamAdd />} />
          <Route path="/seller/service-team-edit/:id" element={<ServiceTeamEdit />} />
          <Route path="/service-man/:id" element={<ServiceProfile />} />
          <Route path="/seller/approval-pending" element={<ApprovalPending />} />
          


          <Route path="/productdetail" element={<ProductDetailtwo />} /> 
          <Route path="/education-training" element={<Education />} /> 
          <Route path="/address-management" element={<AddressManagement />} /> 
          
        
          
          </Routes>



<Whatsapp/>


        </main>
        {/* <Footer/> */}
      </div>
    </Router>
    </CartProvider>
    </HeadProvider>
  );
}

export default App;
